import React from "react";

const Title = ({ sliderCaption }) => {
  const { aciklama1, aciklama2, aciklama3 } = sliderCaption?.[0] || {};
  return (
    <div className="flex flex-col gap-2 mb-3 md:mb-10 sm:mb-5 lg:pb-0 pb-16 items-center">
      <span className="lg:text-[#7B94B0] text-white font-medium leading-normal sm:text-base text-xs">
        {aciklama1 ?? "2000+ villa ile bugüne dek 10000+ misafir ağırladık."}
      </span>
      <div className="lg:text-[2.75rem] md:text-3xl text-xl flex flex-col lg:gap-3 items-center justify-center flex-wrap text-center font-bold leading-normal tracking--tightest md:text-[#004798] text-white">
        <h1 className="flex flex-col gap-2">
          <span>{aciklama2 ?? "Türkiye’nin Güvenilir"}</span>
          <span className="font-normal">
            {aciklama3 ?? "Villa Kiralama Sitesi"}
          </span>
        </h1>
      </div>
    </div>
  );
};

export default Title;
